module.exports = __webpack_public_path__ + "img/WorthMinds.754018af.jpg";